<template>
  <div class="">
    <div class="invisibleStep step2 " v-if="loadPsychologyFieldsSelectedForm && psychologyFields"
         style="cursor: pointer">
      <h4>{{ $t('matchMaking.chooseFieldQuestion') }}</h4>

      <v-row class="mt-10" justify="center">
        <v-col class="text-center" cols="6" lg="3 " v-for="(item , i) in psychologyFields" :key="i">
          <div class="selectableItem"
               v-ripple
               :id="`${item.id}_psychology`"
               :class="psychologyFieldsSelected == item.id ? 'selectableItemActive' : ''"
               @click="setPsychologyFieldsSelected(item.id)">
            <template v-if="$vuetify.rtl">
              {{ item.title }}
            </template>
            <template v-else>
              {{ item.en_title }}
            </template>

          </div>
        </v-col>
      </v-row>
    </div>
    <v-fade-transition>
      <div class="generalHint mt-10" v-if="showHintMessages">
        {{ $t('matchMaking.hintTitle') }}
        <br>
        {{ $t('matchMaking.hintDescription[0]') }}
        <br>
        {{ $t('matchMaking.hintDescription[1]') }}
      </div>
    </v-fade-transition>
    <div class="invisibleStep mt-10" :style="showHintMessages && 'font-size: 18px;font-weight:bolder'"
         :class="`step${this.currentStep}`" v-if="questionRender != null">
      <template v-if="questionRender.answer_record">
        <template v-if="$vuetify.rtl">
          {{ questionRender.answer_record.question.q_text }}
        </template>
        <template v-else>
          {{ questionRender.answer_record.question.q_en_text }}
        </template>
      </template>
      <v-form ref="matchMaking" class="mt-5" v-if="questionRender.answer_record">
        <option-handler-match-making
            :call-change-in-option="callChangeInOption"
            :options="questionRender.answer_record"
            :type="questionRender.answer_record.question.vue_type"
            @prepareData="prepareData"
        />
      </v-form>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
// import {ajaxGet, ajaxPost} from "@/utilities";
import {EventBus} from "@/event-bus";
import gsap from "gsap";
import OptionHandlerMatchMaking from "@/components/MatchMaking/OptionHandlerMatchMaking";

export default {
  components: {OptionHandlerMatchMaking},
  props: {
    language: {
      default: 'fa'
    },
    next: Boolean,
    prev: Boolean,
    callChangeInOption: Boolean,
  },
  data() {
    return {
      showHintMessages: false,
      loadPsychologyFieldsSelectedForm: true,
      psychologyFields: null,
      questionRender: null,
      psychologyFieldsSelected: null,
      currentStep: 1,
      payloadBody: null,
    }
  },
  methods: {
    checkUserHasPendingTest() {
      if (this.$store.getters.userIsLoggedIn || localStorage.getItem('user_token_matchMaking') != 'undefined') {
        this.$emitEvent('setLoading', true)
        this.requesting('match_making', 'initTest', '', '', {
          'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking'),
        }).then((resp) => {
          if (resp.status_code == 404) {
            localStorage.setItem('user_token_matchMaking', null)
            this.getPsychologyFields()
          } else {
            this.loadPsychologyFieldsSelectedForm = false
            this.getQuestions();
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    getPsychologyFields() {
      this.toInVisible();
      this.$emitEvent('setLoading', true)
      this.requesting('match_making', 'getPsychologyFields', '', '', {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }).then((resp) => {
        this.psychologyFields = resp.data
        this.nextStep()
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    getQuestions() {
      this.showHintMessages = false
      this.$emitEvent('setLoading', true)
      let urlName = 'initTestWithOutCheck'
      let param = {}
      let header = {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }
      if (this.psychologyFieldsSelected != null) {
        urlName = 'initTestWithPsychology'
        param = {
          psychology_field_id: this.psychologyFieldsSelected
        }
        header = {}
      }
      this.requesting('match_making', urlName, param, {}, header).then((resp) => {
        if (resp.status_code == 206) {
          this.$emitEvent('setLoading', true)
          this.getResult();
        } else {
          this.$emitEvent('setLoading', false)
          localStorage.setItem('user_token_matchMaking', resp.data.token)
          console.log(localStorage.getItem('user_token_matchMaking'), '12346780]')
          console.log(resp, 'hre')
          this.user_m_test_id = resp.data.answer_record.user_m_test_id
          this.nextStep();
          this.questionRender = resp.data
          console.log(this.questionRender)
        }
      })
    },
    submitAnswer() {
      this.$emitEvent('setStepValue', {
        key: 'temp',
        value: null,
        nextStep: false
      })
      if (Object.keys(this.payloadBody).length === 0 || this.payloadBody.answers.length === 0 || this.payloadBody.answers[0] == undefined) {
        this.$emitEvent('setStepValue', {
          key: 'temp',
          value: null,
          nextStep: false
        })
        this.$emitEvent('notify', 'red', undefined, this.$t('matchMaking.pleaseAnswer'));
        return;
      }
      this.$emitEvent('setLoading', true)
      this.toInVisible(() => {
        if (this.questionRender.answer_record.question_id == 1) {
          this.storeFirstQuestionOption()
        }
        this.questionRender = null
        this.showHintMessages = false
        this.requesting('match_making', 'submitAnswer', '', this.payloadBody, {
          'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
        }).then((resp) => {
          if (resp.status_code == 206) {
            this.getResult();
          } else {
            this.$emit('setLoading', false)
            this.user_m_test_id = resp.data.answer_record.user_m_test_id
            this.nextStep();
            this.questionRender = resp.data
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
          this.payloadBody = {}
        })
      })
    },
    storeFirstQuestionOption() {
      localStorage.setItem('firstQuestionMatchMaking', this.payloadBody.answers[0].question_option_id)
    },
    prepareData(val) {
      this.payloadBody = val
      EventBus.$emit('setStepValue', {
        key: 'temp',
        value: this.payloadBody,
      })
      this.submitAnswer()
    },
    getResult() {
      this.$emitEvent('setLoading', true)
      this.requesting('match_making', 'getTestResult', '', {
        'user_m_test_id': this.user_m_test_id,
      }, {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }).then((resp) => {
        this.$emit('matchMakingTestEnd')
        // this.matchMakingStepper = 4
        // this.$router.push({name: "preorder", params: {orderId: 68}})
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    loadingHandler(val) {
      this.$nextTick().then(() => {
        this.loading = val
      })
    },
    nextStep() {
      gsap.to(`.step${this.currentStep}`, {x: -50, opacity: 0, display: 'none'}).then(() => {
        this.currentStep++;
        if (this.questionRender) {
          if (this.questionRender.answer_record.question_id == 25) {
            this.showHintMessages = true
          }
        }
        this.$nextTick().then(() => {
          gsap.fromTo(`.step${this.currentStep}`, {x: 50, opacity: 0, display: 'none'}, {
            x: 0,
            opacity: 1,
            display: "block"
          })
        })
      });
    },
    toInVisible(callBack = function () {
    }) {
      gsap.to(`.step${this.currentStep}`, .5, {x: -50, opacity: 0, display: 'none'}).then(() => {
        callBack();
      })
    },
    toVisible() {
      this.currentStep++;
      gsap.fromTo(`.step${this.currentStep}`, .5, {x: 50, opacity: 0, display: 'none'}, {
        x: 0,
        opacity: 1,
        display: "block"
      })
    },
    setPsychologyFieldsSelected(val) {
      this.psychologyFieldsSelected = val
      this.getQuestions()
    }
    //   this.psychologyFieldsSelected = val
    //   if (this.currentStep == 2 && this.psychologyFieldsSelected != null) {
    //     return this.getQuestions()
    //   } else {
    //     return this.submitAnswer()
    //   }
    // }
  },
  computed: {
    btnMethod() {

    },
    language() {
      if (this.$store.getters.getLocal === null || this.$store.getters.getLocal === undefined)
        return 'fa';

      return this.$store.getters.getLocal;
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    }
  },
  watch: {
    next(val) {
      if (val) {
        this.submitAnswer()
      }
    },

  },
  mounted() {
    if (!this.$store.getters.userIsLoggedIn) {
      if (localStorage.getItem('user_token_matchMaking') != 'undefined') {
        this.checkUserHasPendingTest()
      } else {
        this.getPsychologyFields()
      }
    } else {
      this.checkUserHasPendingTest()
    }
    // if (this.currentS  tep == 1) {
    //   this.checkUserHasPendingTest()
    // }
    // if (this.currentStep == 2 && this.psychologyFieldsSelected != null) {
    //   return this.getQuestions()
    // } else {
    //   return this.submitAnswer()
    // }
  }
}
</script>

<style scoped>
.generalHint {
  line-height: 25pt;
  font-size: 15px;
}

.selectableItem {
  height: 100%;
  width: 100%;
  font-size: 10pt;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: url("../../assets/matchMaking/backitem.png") no-repeat;
  background-size: cover;
  border: solid 2px #d1dcff;
  position: relative;
  margin: auto;

}


.v-stepper {
  box-shadow: none !important;
}

.main-container-c {
  font-size: 24px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100% !important;
  flex-direction: column;
  z-index: 3 !important;
  transition: all .3s linear;
}

.main-background {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #f9ffff !important;
  z-index: 1;
}

.bg-circles {
  position: absolute;
  z-index: 2;
  filter: blur(46px);
  -webkit-filter: blur(46px);
}

.bg-circles.aqua-circle {
  top: -10%;
  left: -5%;
  width: 30%;
}

.bg-circles.green-circle {
  bottom: 12%;
  right: -10%;
  width: 20%;
}

.bg-circles.purple-circle {
  bottom: -15%;
  left: -5%;
  width: 20%;
}

.flex-navigation {
  width: 100%;
  z-index: 10;
  align-self: flex-start;
}

.stepper-shell {
  /*width: 60%;*/
  height: 80%;
  max-height: 700px;
  box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
  background-color: #fff;
  border-radius: 20px;
}

@media screen and (max-width: 967px ) {
  .stepper-shell {
    max-width: 95% !important;
  }
}

.stepper {
  height: 100%;
  margin: 10px 10px 0 10px;
  position: relative;
  border-radius: 20px;
  overflow-x: hidden !important;
}

.invisibleStep {
  opacity: 0;
  display: none;
}

.stepper-item-colored {
  background-color: #f5faff;
}

.selectableItem {
  font-size: 12pt;
  border: 1px solid #ededed;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s;

}

.selectableItemActive {
  border: 3px solid #4576d8;

}

.actionArea {
  position: absolute;
  bottom: 40px;
  right: 10px;
  left: 10px;
  text-align: center;
}

.start-btn {
  height: 35px !important;
  color: #3CBE8B;
  border-radius: 10px;
  transition: background-color .3s linear;
  font-weight: bolder;
  font-size: 15pt;
}

.start-btn:hover {
  background-color: #daf5eb;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s;
  transform: translateY(0);
  opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(10px);
}
</style>